import '../style.css';
import Library from '../lib/Library.js';
import {Map} from '../lib/Map.js';
import {BaseLayer} from '../lib/BaseLayer.js';
import {MapLayer} from '../lib/MapLayer.js';
import {TafLayer} from '../lib/layers/Taf.js';
import {MousePosition} from '../lib/controls/MousePosition.js';
import {ScaleLine} from '../lib/controls/ScaleLine.js';
import {TimeSlider} from '../lib/controls/TimeSlider.js';
import {FullScreen} from '../lib/controls/FullScreen.js';
import {DateLabel} from '../lib/controls/DateLabel.js';

function init(){
    let map = new Map();
    map.addLayer( new BaseLayer( map, {"type": "globe_light"} ));
    map.addLayer( new MapLayer( map, {"type": "basic"}, {"visible": true } ));
    map.addLayer( new MapLayer( map, {"type": "county"} ));
    map.addLayer( new MapLayer( map, {"type": "highway"} ));
    map.addLayer( new MapLayer( map, {"type": "jetroute"} ));
    map.addLayer( new MapLayer( map, {"type": "fir"} ));
    map.addLayer( new TafLayer( map, {"visible": true} ));
    map.addControl( new MousePosition( map ));
    map.addControl( new ScaleLine( map ));
    map.addControl( new TimeSlider( map, { 
                "min": 0,
                "max": 24,
                "value": 0,
                "onchange": function( val, date ){
                console.info( 'slider', val, date );
                }
                } ));
    map.addControl( new FullScreen( map ));
    map.addControl( new DateLabel( map ));
    map.setupInput();
    map.setLocation();
    map.setTimeout();

    window.map = map;
}

document.addEventListener("DOMContentLoaded", function() {
    init();
});
